/**
 * Notification utilities for triggering UI refreshes
 */

/**
 * Trigger a refresh of notification counts in the Layout component
 * Call this after any action that changes notification/approval counts
 */
export const refreshNotificationCounts = () => {
  window.dispatchEvent(new CustomEvent('refreshNotificationCounts'));
};

/**
 * Trigger a general data refresh event
 * Components can listen for this to refresh their data
 */
export const triggerDataRefresh = (dataType) => {
  window.dispatchEvent(new CustomEvent('dataRefresh', { detail: { dataType } }));
};

export default {
  refreshNotificationCounts,
  triggerDataRefresh
};
